import React from 'react'

import { TextField ,Grid, Typography} from "@mui/material"
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BooleanFilter from '../../core/form/BooleanFilter';
import { useSelector, useDispatch } from 'react-redux';
import { setProduct2skill2exp2rateFilterCriteria } from 'store/slice/ManufSlice';

export default function Product2skill2exp2rateFilterCriteria() {
    const dispatch = useDispatch();
    const {filterCriteria} = useSelector((state)=>state.manufslice.product2skill2exp2rateDashboard);
        
    const {skillList} = useSelector((state)=>state.manufslice);    
    const {explevelList} = useSelector((state)=>state.manufslice);    
    const {mfproductList} = useSelector((state)=>state.manufslice);    
    const {workerList} = useSelector((state)=>state.manufslice);
    
const updateSkillnameCriteria = (skillname) =>{
        dispatch(setProduct2skill2exp2rateFilterCriteria(
            {
                ...filterCriteria,
                skillname:skillname
        }))
    }
const updateProductnameCriteria = (productname) =>{
        dispatch(setProduct2skill2exp2rateFilterCriteria(
            {
                ...filterCriteria,
                productname:productname
        }))
    }
const updateWorkernameCriteria = (workername) =>{
        dispatch(setProduct2skill2exp2rateFilterCriteria(
            {
                ...filterCriteria,
                workername:workername
        }))
    }

    return (

        <Grid container direction="row" lg={12} sx={{justifyContent:'center'}}>
                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Skillname"
                            name="skillname"
                            value={filterCriteria.skillname}
                            onChange={(e)=>updateSkillnameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Productname"
                            name="productname"
                            value={filterCriteria.productname}
                            onChange={(e)=>updateProductnameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>

                    <Grid item lg={4} padding={1}>
                        <TextField type="search" variant="standard"
                            label="Workername"
                            name="workername"
                            value={filterCriteria.workername}
                            onChange={(e)=>updateWorkernameCriteria(e.target.value)}
                            sx={{minWidth:'100px'}}
                        />
                    </Grid>


        </Grid>
    )

}